module.exports = __webpack_public_path__ + "static/img/gaozhongwuli2.e4d6d34a.jpg";